import React, { FunctionComponent, useCallback } from 'react';
import { Presentation } from './presentation';
import { EducationalHistories, CareerHistories, PreferredOccupationItem, CareerEmploymentType } from '../../../types/personShow';

type Props = {
  penIconImg: string;
  title: string;
  value?: string | string[] | { name: { url :string; } };
  type: string;
  id: string;
  word: string;
  array?: string[] | EducationalHistories[] | CareerHistories[] | PreferredOccupationItem[];
  updatedAt?: string;
  personId?: number;
  isShow: boolean;
  unCompleted?: boolean;
  isStudent?: boolean;
  last?: boolean;
  isNotRequested?: boolean;
  isMiddle?: boolean;
  careerEmploymentTypes?: CareerEmploymentType[];
  handleClick: (target: string, title: string) => void;
  onChangeClickTarget?: (value: number) => void;
  handleRequestResume?: (type: string) => void;
};

export const Component: FunctionComponent<Props> = (props) => {
  const onClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (!props.isShow) return;

      const target = (event.currentTarget as HTMLElement).getAttribute('id') || '';
      const title = (event.currentTarget as HTMLElement).querySelector('.title')?.textContent || '';

      if (props.type !== 'histories') {
        props.handleClick(target, title);
      } else if (props.type === 'histories' && props.array?.length === 0) {
        props.handleClick(target, title);
      }
    },
    [props.isShow, props.type, props.array, props.handleClick]
  );

  const onClickHistoriesChild = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      if (!props.isShow) return;

      const text = event.currentTarget.textContent;
      const target = props.id || '';
      const title = props.title || '';

      if (text === '追加') {
        const index = document.querySelectorAll(`#${props.id} .histories`).length;
        props.handleClick(target, title);
        if (props.onChangeClickTarget) props.onChangeClickTarget(index);
      } else {
        const parent = event.currentTarget.closest(`#${props.id}`);
        const target = parent?.getAttribute('id') || '';
        const title = parent?.querySelector('.title')?.textContent || '';
        const nodes = Array.from(document.querySelectorAll(`#${props.id} .histories`));
        const index = nodes.indexOf(event.currentTarget);
        props.handleClick(target, title);
        if (props.onChangeClickTarget) props.onChangeClickTarget(index);
      }
    },
    [props.isShow, props.id, props.title, props.handleClick, props.onChangeClickTarget]
  );

  const onRequestResume = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      const el = event.currentTarget as HTMLElement;
      el.classList.add('disabled');
      if (props.handleRequestResume) props.handleRequestResume(props.id);
    },
    [props.handleRequestResume, props.id]
  );

  const employmentTypeMap = Object.fromEntries(
    (props.careerEmploymentTypes ?? []).map((cet) => [cet.id, cet.name])
  );

  return (
    <Presentation
      id={props.id}
      title={props.title}
      penIconImg={props.penIconImg}
      isShow={props.isShow}
      type={props.type}
      value={props.value}
      array={props.array}
      word={props.word}
      unCompleted={props.unCompleted}
      last={props.last}
      isStudent={props.isStudent}
      isMiddle={props.isMiddle}
      isNotRequested={props.isNotRequested}
      updatedAt={props.updatedAt}
      personId={props.personId}
      employmentTypeMap={employmentTypeMap}
      onClick={onClick}
      onClickHistoriesChild={onClickHistoriesChild}
      onRequestResume={onRequestResume}
    />
  );
};
